export default __webpack_public_path__ + "static/media/qkn-red-full.bd808eb4.svg";